<template>
  <div class="container page" style="background: #1f1c1f;" @click="closeDropdown">
    <van-nav-bar :title="$t('绑卡.添加钱包地址')" class="nav-bar">
      <template #left>
        <img src="/img/common/icon-back.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>

    <div class="main-box">
      <div class="label">{{ $t('绑卡.请输入支付卡信息') }}</div>

      <div class="form-group">

        <!-- 币种自定义下拉 -->
        <div class="field-wrap">
          <div class="field-label">{{ $t('绑卡.加密货币类型') }}</div>
          <div class="dropdown-wrap" @click.stop="toggleDropdown">
            <div class="dropdown-trigger" :class="{ active: showDropdown }">
              <span :class="selectedCrypto ? 'trigger-value' : 'trigger-placeholder'">
                {{ selectedCrypto || $t('绑卡.请选择加密货币类型') }}
              </span>
              <span class="trigger-arrow" :class="{ open: showDropdown }">▾</span>
            </div>

            <!-- 下拉选项 -->
            <div v-if="showDropdown" class="dropdown-menu">
              <div
                v-for="item in cryptoList"
                :key="item.value"
                class="dropdown-item"
                :class="{ selected: selectedCrypto === item.label }"
                @click.stop="selectCrypto(item)"
              >
                <span class="item-icon">{{ item.icon }}</span>
                <span class="item-label">{{ item.label }}</span>
                <span v-if="selectedCrypto === item.label" class="item-check">✓</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 地址输入 -->
        <div class="field-wrap">
          <div class="field-label">{{ $t('绑卡.钱包地址') }}</div>
          <div class="field-input-wrap">
            <input
              v-model="address"
              class="field-input"
              :placeholder="$t('绑卡.请输入钱包地址')"
              :disabled="isBound"
              :readonly="isBound"
            />
          </div>
        </div>

      </div>

      <p>{{ $t('绑卡.绑卡说明') }}</p>
    </div>

    <div v-if="!isBound" class="sub-btn" @click="bindCard()">
      {{ $t('绑卡.确定绑卡') }}
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      selectedCrypto: '',
      selectedCryptoValue: '',
      address: '',
      showDropdown: false,
      isBound: false,
      cryptoList: [
        { label: 'BTC', value: 'BTC', icon: '₿' },
        { label: 'ETH', value: 'ETH', icon: 'Ξ' },
      ],
    }
  },

  methods: {
    back() {
      return window.history.back()
    },

    toggleDropdown() {
      if (this.isBound) return
      this.showDropdown = !this.showDropdown
    },

    closeDropdown() {
      this.showDropdown = false
    },

    selectCrypto(item) {
      if (this.isBound) return
      this.selectedCrypto = item.label
      this.selectedCryptoValue = item.value
      this.showDropdown = false
    },

    bindCard() {
      if (this.isBound) {
        this.$toast(this.$t('绑卡.已绑定不可修改'))
        return
      }
      if (!this.selectedCrypto) {
        this.$toast.fail(this.$t('绑卡.请选择加密货币类型'))
        return
      }
      if (!this.address.trim()) {
        this.$toast.fail(this.$t('绑卡.请输入钱包地址'))
        return
      }

      this.$http({
        method: 'post',
        data: {
          chain: this.selectedCrypto,
          address: this.address.trim(),
        },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg)
          this.$router.replace({ path: '/Setbank' })
        } else {
          this.$toast(res.msg)
        }
      })
    },

    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
        }
      })
    },

    getUserBankInfo() {
      this.$http({ method: 'get', url: 'user_get_bank' }).then(res => {
        if (res.code === 200 && res.data.is_bank) {
          this.isBound = true
          this.$toast(this.$t('绑卡.已绑定不可修改'))
          this.$router.replace({ path: '/Setbank' })
        }
      })
    },
  },

  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo()
      this.getUserBankInfo()
    }
  }
}
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

// ── 标题提示 ──────────────────────────────────────────
.main-box .label {
  padding: 20px 0 20px 26px;
  font-size: 35px;
  color: #f3c7a2;
}

.main-box p {
  padding: 0 20px;
  font-size: 30px;
  color: #f3c7a2;
  margin-top: 20px;
}

// ── 表单区域 ──────────────────────────────────────────
.form-group {
  padding: 30px 30px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.field-wrap {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.field-label {
  font-size: 28px;
  color: #ccc;
  padding-left: 4px;
}

// ── 地址输入框 ────────────────────────────────────────
.field-input-wrap {
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  border-radius: 10px;
  padding: 20px 26px;
}

.field-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-size: 28px;
  color: #f3c7a2;

  &::placeholder { color: #555; }
}

// ── 自定义下拉 ────────────────────────────────────────
.dropdown-wrap {
  position: relative;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  border-radius: 10px;
  padding: 20px 26px;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &.active {
    border-color: #e6b98a;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .trigger-value {
    font-size: 28px;
    color: #f3c7a2;
    font-weight: 600;
  }

  .trigger-placeholder {
    font-size: 28px;
    color: #555;
  }

  .trigger-arrow {
    font-size: 28px;
    color: #766350;
    transition: transform 0.25s ease;

    &.open { transform: rotate(180deg); }
  }
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: linear-gradient(120deg, #2a2a2a, #383838);
  border: 1px solid #e6b98a;
  border-top: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  z-index: 100;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px 26px;
  cursor: pointer;
  transition: background 0.15s ease;
  border-bottom: 1px solid #333;

  &:last-child { border-bottom: none; }

  &:active,
  &:hover { background: rgba(230, 185, 138, 0.08); }

  &.selected {
    background: rgba(230, 185, 138, 0.12);

    .item-label { color: #e6b98a; font-weight: 700; }
  }

  .item-icon {
    font-size: 32px;
    color: #f7931e;
    width: 40px;
    text-align: center;
  }

  .item-label {
    flex: 1;
    font-size: 30px;
    color: #f3c7a2;
    font-weight: 500;
  }

  .item-check {
    font-size: 28px;
    color: #e6b98a;
    font-weight: 700;
  }
}

// ── 提交按钮 ──────────────────────────────────────────
.sub-btn {
  background: linear-gradient(#fde3ca, #e7b486);
  display: block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  border-radius: 2rem;
  margin: 60px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
  transition: all 0.2s ease;

  &:active {
    opacity: 0.85;
    transform: scale(0.98);
  }
}
</style>
